import { ReactElement } from 'react'

const WishlistPdp = ({ ...props }): ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            {...props}
        >
            <path
                fill="url(#paint0_linear_2:4994)"
                d="M11.75.938c-.868 0-1.664.275-2.366.817-.673.52-1.12 1.183-1.384 1.665-.264-.482-.712-1.145-1.384-1.665A3.788 3.788 0 004.25.938C1.827.938 0 2.918 0 5.548c0 2.838 2.28 4.781 5.73 7.722.586.5 1.25 1.065 1.94 1.669a.5.5 0 00.66 0c.69-.604 1.354-1.17 1.94-1.67C13.72 10.33 16 8.386 16 5.547c0-2.628-1.827-4.61-4.25-4.61z"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2:4994"
                    x1="5.544"
                    x2="14.355"
                    y1="23.961"
                    y2="23.791"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FAA36B" />
                    <stop offset="1" stopColor="#FC5E67" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default WishlistPdp
